import { Text } from "@corpuscomplete/web-ui/components/text";
import { AlertTriangleIcon } from "lucide-react";
import { AgentTools } from "@corpuscomplete/core-ui/ai/agent/tools";

export function ToolError({ errorText }: { errorText?: string }) {
  const displayMessage = AgentTools.getToolErrorDisplayText(errorText);

  return (
    <div className="mb-4 flex flex-row justify-start">
      <div className="flex items-start gap-2 rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-2">
        <AlertTriangleIcon className="mt-0.5 h-4 w-4 shrink-0 text-destructive" />
        <Text variant="sm" className="text-destructive">
          {displayMessage}
        </Text>
      </div>
    </div>
  );
}
